module.exports = __webpack_public_path__ + "static/img/r-8.57a341c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-8.jpg
// module id = 08mI
// module chunks = 0